export default __webpack_public_path__ + "static/article-car-safety-made-easy-technology-and-tips-1eac0320436f0e67840b96b6bddb828a.jpg";